<template>
  <div id="app">
    <notifications
      transition-name="notification-list"
      transition-mode="out-in"
    />
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>
<script>
import 'vue-notifyjs/themes/default.css'

export default {
  name: 'App',
  data: function () {
    return {
    }
  },
  computed: {
    layout: function () {
      return this.$route.meta.layout + '-layout'
    }
  }
}
</script>
